var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 184,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0A2832",
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.747 87.224H28.77l5.008 20.002h6.657l-6.657-26.659H22.051l18.353-20.033h-8.178L13.746 80.41V60.534H7.09v46.66h6.657v-19.97ZM93.782 107.194l20.001-33.283v33.283h6.656V60.502h-6.656l-20 33.474V60.534h-6.689v46.66h6.688ZM153.784 80.536h-20.159V60.534h-6.656v46.66h6.656V87.192h20.159v20.002h6.657v-46.66h-6.657v20.002ZM53.75 7.186h26.656v40.003h6.688V.529H47.093v46.66h6.656V7.186ZM7.123 47.221h6.656l2.758-9.795H33.78v9.763h6.656V.498H20.594v.063h-.127l-8.622 30.177h-2.82l-1.902 6.657h2.789l-2.79 9.826ZM25.095 7.186h8.685V30.77H18.438l6.657-23.584ZM160.092.498h-19.493v.063h-.095l-8.654 30.177h-2.821l-1.902 6.657h2.821l-2.821 9.794h6.657l2.757-9.794h17.275v9.763h6.657V.498h-.381Zm-21.649 30.24L145.1 7.155h8.716v23.583h-15.373ZM127.064 15.618v-.064c0-8.02-6.054-14.613-13.661-14.993H93.751v46.66h6.656V30.706l12.203-.032c7.924 0 14.391-6.688 14.391-15.025v-.031h.063Zm-15.278 8.526h-11.347V7.123h11.347c4.501 0 8.146 3.803 8.146 8.495 0 4.723-3.645 8.526-8.146 8.526ZM146.747 120.54H127.095v46.659h6.656v-16.546l12.203-.032c7.925 0 14.391-6.688 14.391-15.025v-.063c.063-8.02-6.023-14.613-13.598-14.993Zm-1.617 23.551h-11.347v-17.022h11.347c4.501 0 8.146 3.804 8.146 8.495 0 4.723-3.645 8.527-8.146 8.527ZM70.58 138.638V120.57H47.125v46.66h17.052c7.925 0 14.39-6.688 14.39-15.025v-.095c0-5.896-3.264-10.999-7.987-13.472Zm-6.656-11.411v9.858H53.813v-9.858h10.11Zm-.602 33.441h-9.51v-17.021h9.51c4.5 0 8.146 3.803 8.146 8.495 0 4.723-3.645 8.526-8.146 8.526ZM38.566 160.574h-4.818v-40.003h-3.296v-.031H13.778v40.034H8.993l-1.934 6.657h20.033v.032h6.656v-.032h6.688l-1.87-6.657Zm-18.13 0v-33.346h6.656v33.346h-6.657ZM101.991 119.239c-11.284 0-20.413 11.031-20.413 24.63 0 13.598 9.129 24.629 20.413 24.629s20.413-11.031 20.413-24.629c0-13.599-9.129-24.63-20.413-24.63Zm0 42.603c-7.576 0-13.725-8.052-13.725-17.973 0-9.89 6.15-17.973 13.725-17.973 7.576 0 13.725 8.051 13.725 17.973.032 9.889-6.149 17.973-13.725 17.973ZM63.512 66.018c5.769 0 10.301 3.645 12.584 9.7 0 0 3.835-2.537 5.641-4.407-3.106-7.417-10.586-12.077-18.225-12.077-11.792 0-21.364 11.031-21.364 24.63 0 13.598 9.572 24.629 21.364 24.629 6.434 0 12.235-3.296 16.133-8.495-2.694-2.409-5.23-4.564-5.23-4.564-2.63 3.835-6.56 6.276-10.935 6.276-7.924 0-14.39-8.02-14.39-17.846.031-9.858 6.497-17.846 14.422-17.846Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h169.091v182.727H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 169.414,
    height: 184,
    x: -0.941,
    y: 0.498,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_607_12340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_607_12340",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongLogo5);
export default __webpack_public_path__ + "static/media/wrong-logo-5.6d5283fdc9ee9866f2a54187c3424aee.svg";
export { ForwardRef as ReactComponent };